import { Unity4Claim } from '@adreno-common';
import { RouteInfo } from './route-info';

export const menuItems: RouteInfo[] = [
  {
    path: '/news',
    title: 'News',
    icon: 'fas fa-newspaper',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    claim: Unity4Claim.NewsModule,
    submenu: [],
  },
  {
    path: '/work',
    title: 'Go To Work',
    icon: 'mdi mdi-phone-log',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    claim: Unity4Claim.WorkModule,
    submenu: [],
  },
  {
    path: '/availability',
    title: 'Go To Work',
    icon: 'mdi mdi-phone-log',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    claim: Unity4Claim.WorkViaAvailabilityModule,
    submenu: [],
  },
  {
    path: '/training',
    title: 'Training',
    icon: 'fas fa-chalkboard-teacher',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    claim: Unity4Claim.TrainingModule,
    submenu: [],
  },
  {
    path: '/reports',
    title: 'Reports',
    icon: 'fas fa-chart-line',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    claim: Unity4Claim.AgentReportsModule,
    submenu: [],
  },
  {
    path: '/timesheets',
    title: 'Timesheets',
    icon: 'fas fa-clipboard-list',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    claim: Unity4Claim.TimesheetsModule,
    submenu: [],
  },
  {
    path: '/testing',
    title: 'Testing',
    icon: 'fas fa-flask',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    claim: Unity4Claim.TestingModule,
    submenu: [],
  },
];
